module.exports = __webpack_public_path__ + "media/images/payments/square-8eb827859b2d4feebe22743c0730cda8.svg";